import { render, staticRenderFns } from "./ServiceDataViewSidebar.vue?vue&type=template&id=037caa7a&scoped=true&"
import script from "./ServiceDataViewSidebar.vue?vue&type=script&lang=js&"
export * from "./ServiceDataViewSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDataViewSidebar.vue?vue&type=style&index=0&id=037caa7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037caa7a",
  null
  
)

export default component.exports